import { useCallback, useState } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import MinimizedBetaButton from 'ui-addon-opt/components/MinimizedBetaButton';

// @ts-expect-error not typed yet
import { CSSTransitionGroup } from 'react-transition-group';
import { isValidCsatResponse } from './EPCsatResponseUtils';
import EpCsatSurveyForm from './EpCsatSurveyForm';
import EpSurveyThankYou from './EPCsatSurveyThankYou';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SurveyWrapper = styled.div.withConfig({
  displayName: "EPCsatSurvey__SurveyWrapper"
})([".fade-enter{opacity:0;}.fade-enter-active{opacity:1;transition:opacity 500ms;}.fade-exit{opacity:1;}.fade-exit-active{opacity:0;transition:opacity 500ms;}"]);
const FEEDBACK_BUTTON_STATES = {
  PROMT: 'PROMT',
  FEEDBACK: 'FEEDBACK',
  SUBMITTED: 'SUBMITTED'
};
const CsatSurveyWrapper = styled.div.withConfig({
  displayName: "EPCsatSurvey__CsatSurveyWrapper"
})(props => {
  var _props$width;
  return {
    position: 'fixed',
    bottom: '17px',
    left: '0px',
    width: `${(_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 450}px`,
    zIndex: 900
  };
});
function EPCsatSurveyPrompt({
  title,
  onDismiss,
  onClick
}) {
  return /*#__PURE__*/_jsx(MinimizedBetaButton, {
    icon: "none",
    onClick: onClick,
    children: /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      justify: "between",
      children: [title !== null && title !== void 0 ? title : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "epCsatSurvey.prompt.label"
      }), /*#__PURE__*/_jsx(IconButton, {
        onClick: onDismiss,
        use: "unstyled",
        size: "extra-small",
        marginInlineEnd: "200",
        marginInlineStart: "200",
        children: /*#__PURE__*/_jsx(RemoveIcon, {
          color: "icon-primary-default"
        })
      })]
    })
  });
}
const EPCsatSurvey = ({
  onDismiss,
  onSubmit,
  mainTitle,
  formTitle
}) => {
  const [feedbackButtonState, setFeedbackButtonState] = useState(FEEDBACK_BUTTON_STATES.PROMT);
  const [response, setResponse] = useState({
    canContact: false
  });
  const submitResponse = useCallback(() => {
    if (!isValidCsatResponse(response)) {
      console.error('Unexpectedely called submit with an invalid response, aborting');
      return;
    }
    onSubmit(response);
    setFeedbackButtonState(FEEDBACK_BUTTON_STATES.SUBMITTED);
  }, [onSubmit, response]);
  const onOpenSurvey = useCallback(() => {
    setFeedbackButtonState(FEEDBACK_BUTTON_STATES.FEEDBACK);
  }, []);
  const updateCsatResponse = useCallback(partialResponse => {
    setResponse(resp => Object.assign({}, resp, partialResponse));
  }, []);
  return /*#__PURE__*/_jsx(SurveyWrapper, {
    children: /*#__PURE__*/_jsxs(CSSTransitionGroup, {
      transitionName: "fade",
      transitionEnterTimeout: 600,
      transitionLeaveTimeout: 400,
      children: [feedbackButtonState === FEEDBACK_BUTTON_STATES.PROMT && /*#__PURE__*/_jsx(EPCsatSurveyPrompt, {
        onClick: onOpenSurvey,
        title: mainTitle,
        onDismiss: onDismiss
      }), feedbackButtonState === FEEDBACK_BUTTON_STATES.FEEDBACK && /*#__PURE__*/_jsx(CsatSurveyWrapper, {
        children: /*#__PURE__*/_jsx(EpCsatSurveyForm, {
          updateCsatResponse: updateCsatResponse,
          title: formTitle,
          csatResponse: response,
          onSubmit: submitResponse,
          onDismiss: onDismiss
        })
      }), feedbackButtonState === FEEDBACK_BUTTON_STATES.SUBMITTED && /*#__PURE__*/_jsx(CsatSurveyWrapper, {
        children: /*#__PURE__*/_jsx(EpSurveyThankYou, {
          onDismiss: onDismiss
        })
      })]
    })
  });
};
export default EPCsatSurvey;